<template>
  <aha-modal
    v-if="isModalShowing"
    @hide="hide()"
    title="Edit Folder"
  >
    <form @submit.prevent="handleEditFolder()">
      <div class="relative">
        <aha-input
          focus
          :maxLength="100"
          v-model="folderName"
          class="mt-1"
        />
      </div>
    </form>
    <template #action>
      <aha-link @click="hide()">
        <span class="font-bold">Cancel</span>
      </aha-link>
      <aha-button
        :disabled="isUpdatingFolder || folderName.length === 0"
        @click="handleEditFolder()"
        has-margin-left
      >
        <aha-spinner variant="white" v-if="isUpdatingFolder" class="mr-1" />
        Save
      </aha-button>
    </template>
    <div class="pt-2 text-red-50" v-if="textError">
      {{ textError }}
    </div>
  </aha-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

// api
import FolderApi from '@/api/folder'

// utils
import Utils from '@/util'

// constants
import constants from '@/constant'

export default {
  props: {
    folder: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      folderName: '',
      isUpdatingFolder: false,
      textError: '',
      isModalShowing: false,
    }
  },
  computed: {
    ...mapState({
      folders: (state) => state.folders,
    }),
  },
  mounted() {
    this.isModalShowing = true
    this.folderName = this.folder.folderName || ''
  },
  methods: {
    ...mapActions([
      'setFoldersAction',
    ]),
    gaTrackEvent(label, value) {
      Utils.gaTrackEvent(
        constants.gaCategories.PRESENTATION_LIST,
        label,
        value,
      )
    },
    handleAfterCallAPIRenameFolder(renamedFolderId) {
      let oldFolderName = ''
      const newFolder = this.folders.map((item) => {
        if (item.folderId === renamedFolderId) {
          oldFolderName = item.folderName
          return { ...item, folderName: this.folderName }
        }
        return item
      })
      this.setFoldersAction(newFolder)
      this.isUpdatingFolder = false
      const toastMessage = `"${oldFolderName}" ranamed to "${this.folderName}"`
      Utils.showToastSuccess(toastMessage)
      Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_LIST, 'Presentation List > Rename Folder > Succeeded', `Folder name: ${this.folderName}`, null, {
        isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
        isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
        role: this.$store.state.currentUser.accountRole || null,
        teamId: this.$store.state.currentAccount.id || null,
        folderId: renamedFolderId,
      })
      this.hide()
    },
    handleErrorRenameFolder(err, text) {
      this.isUpdatingFolder = false
      if (err.body.message === 'folderName must be unique') {
        this.textError = 'This folder name is already in use, please enter something else.'
      } else {
        Utils.showToastError(text)
      }
    },
    async handleEditFolder() {
      this.isUpdatingFolder = true
      this.gaTrackEvent(
        'Presentation List > Rename Folder > Submit',
      )
      if (this.folderName.trim() === '') {
        this.textError = 'Please enter a name for folder.'
        this.isUpdatingFolder = false
        return
      }
      if (this.folderName === this.folder.folderName) {
        this.textError = 'This is your current folder name.'
        this.isUpdatingFolder = false
        return
      }
      try {
        const result = await FolderApi.editTeamFolderById(
          this.$store.state.currentAccount.id,
          this.folder.folderId, {
            folderName: this.folderName.trim(),
          },
        )
        this.handleAfterCallAPIRenameFolder(result.folder.folderId)
      } catch (error) {
        this.handleErrorRenameFolder(error, 'Rename folder failed')
        this.gaTrackEvent(
          'Presentation List > Rename Folder > Failed',
          `Error: ${error.body.message}`,
        )
      }
    },
    hide() {
      this.$emit('hide')
    },
    isValidatedFolderName() {
      if (this.folderName.trim() === '') {
        this.textError = 'Please enter a name for folder.'
        this.isUpdatingFolder = false
        return false
      }
      if (this.folderName === this.folder.folderName) {
        this.textError = 'This is your current folder name.'
        this.isUpdatingFolder = false
        return false
      }
      return true
    },
  },
}
</script>
<style scoped lang="scss">
.must-have-icon {
  font-size: 6px;
  color: red;
  margin-left: 0.25rem;
}
</style>
